import { connect } from "react-redux";
import Button from "./Button";

export function mapStateToProps(state) {
  return {
    layout: state.layoutReducer.layout,
    disabled:
      state &&
      state.preferenceReducer &&
      state.preferenceReducer.IsValueChanged === false ? true :
      state &&
      state.policyReducer &&
      state.policyReducer.policyDetails &&
      state.policyReducer.policyDetails.IsInternalView,
    IsContactValueDisabled: 
      state &&
      state.preferenceReducer &&
      state.preferenceReducer.IsValueChanged,
    IsInternalView:
      state &&
      state.policyReducer &&
      state.policyReducer.policyDetails &&
      state.policyReducer.policyDetails.IsInternalView,
  };
}

export default connect(mapStateToProps)(Button);
